import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPromotionInformation } from "../../../actions/makeAWish";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import Loading from "../../Loading";
import { IAppState } from "../../../types/stores";
import moment from "moment";

type Props = {
    id: string;
    promoId: string;
};

const PromotionDataForm: React.FC<Props> = ({ id, promoId }: Props) => {
    const dispatch = useDispatch();

    const tableCell = {
        fontSize: "16px",
        alignSelf: "center",
        fontFamily: "Roboto",
    };

    const promotionData = useSelector((state: IAppState) => state.makeAWish.promotionData);
    const isPromotionsLoading = useSelector((state: IAppState) => state.makeAWish.isPromotionsLoading);

    useEffect(() => {
        dispatch(getPromotionInformation(id, promoId)); // left
    }, [id, promoId, dispatch]);

    useEffect(() => {
        //create the full list of options
        getPromotionInformation(id, promoId);
    }, [id, promoId]);

    return (
        <div className="row m-t">
            <div className="col-sm-16 text-nowrap" style={{ height: "450px", width: "850px" }}>
                {isPromotionsLoading ? (
                    <Loading />
                ) : Object.keys(promotionData).length != 0 ? (
                    <TableContainer style={{ maxHeight: "68vh" }}>
                        <Table stickyHeader className={""}>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Promo Id:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promoId}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Mailing Date:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.APPEAL_MAILING_DATE
                                            ? moment(promotionData.APPEAL_MAILING_DATE, "MM/DD/YYYY")
                                                  .format("MM/DD/YYYY")
                                                  .toString()
                                            : promotionData.APPEAL_MAILING_DATE}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Zip Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.ZIP_CODE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Appeal Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.APPEAL_CODE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Service Center:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.SERVICE_CENTER}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Frequency:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.FREQUENCY_DESCRIPTION}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Mailing:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.MAILING_DESCRIPTION}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Classification:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.CLASSIFICATION_DESCRIPTION}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Letter Text:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.LETTER_TEXT_DESCRIPTION}
                                    </TableCell>
                                    <TableCell style={{ ...tableCell }}>Letter Package:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.LETTER_PACKAGE_DESCRIPTION}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Monetary/List Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {promotionData.MONETARY_LIST_CODE_DESCRIPTION}
                                    </TableCell>
                                    <TableCell style={{ ...tableCell }}>Recency:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.RECENCY_DESCRIPTION}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Ignore Ind:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.IGNORE_IND}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Old Appeal:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{promotionData.OLD_APPEAL}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <p>{"No Promotion Data to display."}</p>
                )}
            </div>
        </div>
    );
};

export default PromotionDataForm;
